<template>
  <div>
    <el-row class="mb-16">
      <el-col :span="14">
        <el-button
          type="primary"
          class="new-menu-item"
          @click="visiable = true"
          v-auth="'customer::customer-manager::tag-add'"
        >
          {{ $t('customer::customer-manager::tag_add') }}
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="card-box">
      <el-col :span="24">
        <z-table
          :columns="columns"
          :data="tableData"
          :max-height="600"
          :pagination="false"
          v-loading="loading"
          :customDefault="{
            desc: $t('system::common::tips::quick_setting'),
            buttons: [
              {
                btnClick: initCustomerTag,
                text: $t('customer::customer-manager::tag_init'),
                type: 'text'
              }
            ]
          }"
        >
          <template #operate="{ row }">
            <span>
              <el-button @click="handleEdit(row)" type="text" v-auth="'customer::customer-manager::tag-edit'">
                {{ $t('customer::customer-manager::edit') }}
              </el-button>
              <el-button
                @click="handleDel(row)"
                type="text"
                style="color: red"
                v-auth="'customer::customer-manager::tag-delete'"
              >
                {{ $t('customer::customer-manager::delete') }}
              </el-button>
            </span>
          </template>
        </z-table>
      </el-col>
    </el-row>
    <el-dialog
      :title="`${editId ? $t('customer::customer-manager::tag_edit') : $t('customer::customer-manager::tag_add')}`"
      :visible.sync="visiable"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form ref="form" :model="params" :rules="rules" label-width="80px" @submit.native.prevent>
        <el-form-item :label="$t('customer::customer-manager::tag')" prop="name">
          <el-input v-model.trim="params.name" :maxlength="20" @keyup.enter.native="addTag"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visiable = false">{{ $t('customer::customer-manager::cancel') }}</el-button>
        <el-button type="primary" @click="addTag" v-loading="saveLoading">
          {{ $t('customer::customer-manager::confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDicByCode, postUpdateDicByCode, initDataDict } from '@/server/common'
export default {
  data() {
    return {
      tableData: [],
      params: {
        name: ''
      },
      loading: false,
      visiable: false,
      saveLoading: false,
      editId: '',
      columns: [
        {
          label: this.$t('customer::customer-manager::sort_code'),
          prop: 'id',
          type: 'index',
          fixed: 'left',
          width: '80'
        },
        {
          label: this.$t('customer::customer-manager::level'),
          prop: 'name',
          minWidth: '150'
        },
        {
          label: this.$t('customer::customer-manager::opt'),
          fixed: 'right',
          prop: 'operate'
        }
      ],
      rules: {
        name: [{ required: true, message: this.$t('customer::customer-manager::tag_delete_not'), trigger: 'blur' }]
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.loading = true
      const { data } = await getDicByCode(8)
      this.loading = false
      if (data.code === this.$code) {
        this.tableData = data.data
      }
    },
    async initCustomerTag() {
      const { data } = await initDataDict({
        code: 'customer_tag'
      })
      if (data.code === this.$code) {
        this.$message.success($t('system::tip::control_success'))
        this.init()
      }
    },
    addTag() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          let tempList = []
          if (this.editId) {
            tempList = this.tableData.map(item => {
              if (item.id === this.editId) {
                return {
                  ...item,
                  name: this.params.name
                }
              } else return item
            })
          } else {
            tempList = [
              ...this.tableData,
              {
                name: this.params.name,
                sequence: this.tableData.length
              }
            ]
          }
          this.send(tempList).then(_ => {
            this.$message.success(
              `${this.editId ? this.$t('system::tip::edit_success') : this.$t('system::tip::add_success')}`
            )
            this.editId = ''
          })
        }
      })
    },
    async send(tableData = this.tableData) {
      this.saveLoading = true
      const { data } = await postUpdateDicByCode({
        type: 8,
        items: [...tableData]
      })
      this.saveLoading = false
      return new Promise(resolve => {
        if (data.code === this.$code) {
          this.init()
          this.visiable = false
          this.params.name = ''
          resolve()
        }
      })
    },
    handleEdit(row) {
      this.params.name = row.name
      this.editId = row.id
      this.visiable = true
    },
    handleDel(row) {
      this.$confirm(
        this.$t('customer::customer-manager::tag_delete_tips'),
        this.$t('customer::customer-manager::tips'),
        {
          confirmButtonText: this.$t('customer::customer-manager::confirm'),
          cancelButtonText: this.$t('customer::customer-manager::cancel')
        }
      ).then(async () => {
        const tempList = [...this.tableData]
        const index = tempList.findIndex(item => row.id === item.id)
        tempList[index].status = 0
        await this.send(tempList)
        this.$message.success(this.$t('system::tip::delete_success'))
      })
    }
  },
  watch: {
    visiable(val) {
      if (!val) {
        this.params.name = ''
        this.$nextTick(() => this.$refs.form.clearValidate())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.right-box {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.search-input {
  width: 200px;
  margin-left: 10px;
}
</style>
